import { useState, useEffect, useRef } from 'react';
import './ExerciseLoader.css';

const TOTAL_SEGMENTS = 10;
const FILL_INTERVAL  = 200;  // ms per segment fill
const HOLD_DURATION  = 400;  // ms pause once full before exit fade starts

export default function ExerciseLoader() {
  const [filled,  setFilled]  = useState(0);
  const [exiting, setExiting] = useState(false);
  const [gone,    setGone]    = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    // Fill segments one by one
    intervalRef.current = setInterval(() => {
      setFilled((prev) => {
        if (prev >= TOTAL_SEGMENTS) {
          clearInterval(intervalRef.current);
          // Hold briefly then fade out
          setTimeout(() => setExiting(true), HOLD_DURATION);
          setTimeout(() => setGone(true),    HOLD_DURATION + 600);
          return prev;
        }
        return prev + 1;
      });
    }, FILL_INTERVAL);

    return () => clearInterval(intervalRef.current);
  }, []);

  if (gone) return null;

  return (
    <div className={`exercise-loader${exiting ? ' loader--exit' : ''}`}>
      <div className="loader-bar-track">
        {Array.from({ length: TOTAL_SEGMENTS }).map((_, i) => (
          <div
            key={i}
            className={`loader-segment${i < filled ? ' active' : ''}`}
          />
        ))}
      </div>
      <span className="loader-label">Loading…</span>
    </div>
  );
}